import { Alert, AlertDescription } from "@chakra-ui/react";

export const AlertDialog = (props) => {
  const { variant, message } = props;

  return (
    <Alert 
      key={variant ? variant : "alertkey"} 
      status={variant ? variant : "error"}
      borderRadius="5px" mb="1rem"
    >
      <AlertDescription>{message ? message : "Error"}</AlertDescription>
    </Alert>
  );
};
